import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import Header from '../components/Header';
import Sidebar from 'components/Sidebar';
import Toolbar from 'components/Toolbar';

export default function MainLayout() {

    const [sidebar, setSidebar] = useState(false);
    const location = useLocation();
    const pathName = location?.pathname;
    let isHome = false;

    if (pathName === '/') {
        isHome = true;
    }

    const ContainerClasses = classNames({
        "h-screen": true,
        "md:pl-60": true
    })

    return (
        <div>
            <Sidebar
                visible={sidebar}
                setVisible={() => setSidebar(!sidebar)}
                pathName={pathName}
                minified={true}
            />

            <main className={ContainerClasses}>
                <Header
                    isHome={isHome}
                    mobileMenuAction={() => setSidebar(!sidebar)}
                />
                <Outlet />
            </main>

            <Toolbar pathname={pathName} />
        </div>
    )
}
